import { combineReducers } from 'redux'
import {
  HARGA_JUAL_ADD_ERROR,
  HARGA_JUAL_ADD_LOADING,
  HARGA_JUAL_ADD_SUCCESS,
  HARGA_JUAL_LIST_CONTAINER_ERROR,
  HARGA_JUAL_LIST_CONTAINER_LOADING,
  HARGA_JUAL_LIST_CONTAINER_SUCCESS,
  HARGA_JUAL_LIST_JADWAL_ERROR,
  HARGA_JUAL_LIST_JADWAL_LOADING,
  HARGA_JUAL_LIST_JADWAL_SUCCESS,
  HARGA_JUAL_LIST_TRAYEK_ERROR,
  HARGA_JUAL_LIST_TRAYEK_LOADING,
  HARGA_JUAL_LIST_TRAYEK_SUCCESS,
  HARGA_JUAL_UPDATE_ERROR,
  HARGA_JUAL_UPDATE_LOADING,
  HARGA_JUAL_UPDATE_SUCCESS
  } from '../actions/constant'

const priceDishubListTrayekError = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_TRAYEK_ERROR:
      return action.priceDishubListTrayekError
    default:
      return state
  }
}

const priceDishubListTrayekLoading = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_TRAYEK_LOADING:
      return action.priceDishubListTrayekLoading
    default:
      return state
  }
}

const priceDishubListTrayekSuccess = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_TRAYEK_SUCCESS:
      return action.priceDishubListTrayekSuccess
    default:
      return state
  }
}

const priceDishubListTrayek = (state = [], action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_TRAYEK_SUCCESS:
      return action.priceDishubListTrayek
    default:
      return state
  }
}

const priceDishubListScheduleError = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_JADWAL_ERROR:
      return action.priceDishubListScheduleError
    default:
      return state
  }
}

const priceDishubListScheduleLoading = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_JADWAL_LOADING:
      return action.priceDishubListScheduleLoading
    default:
      return state
  }
}

const priceDishubListScheduleSuccess = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_JADWAL_SUCCESS:
      return action.priceDishubListScheduleSuccess
    default:
      return state
  }
}

const priceDishubListSchedule = (state = [], action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_JADWAL_SUCCESS:
      return action.priceDishubListSchedule
    default:
      return state
  }
}

const priceDishubListContainerError = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_CONTAINER_ERROR:
      return action.priceDishubListContainerError
    default:
      return state
  }
}

const priceDishubListContainerLoading = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_CONTAINER_LOADING:
      return action.priceDishubListContainerLoading
    default:
      return state
  }
}

const priceDishubListContainerSuccess = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_CONTAINER_SUCCESS:
      return action.priceDishubListContainerSuccess
    default:
      return state
  }
}

const priceDishubListContainer = (state = [], action) => {
  switch (action.type) {
    case HARGA_JUAL_LIST_CONTAINER_SUCCESS:
      return action.priceDishubListContainer
    default:
      return state
  }
}

const priceDishubAddError = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_ADD_ERROR:
      return action.priceDishubAddError
    default:
      return state
  }
}

const priceDishubAddLoading = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_ADD_LOADING:
      return action.priceDishubAddLoading
    default:
      return state
  }
}

const priceDishubAddSuccess = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_ADD_SUCCESS:
      return action.priceDishubAddSuccess
    default:
      return state
  }
}

const priceDishubAdd = (state = [], action) => {
  switch (action.type) {
    case HARGA_JUAL_ADD_SUCCESS:
      return action.priceDishubAdd
    default:
      return state
  }
}

const priceDishubUpdateError = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_UPDATE_ERROR:
      return action.priceDishubUpdateError
    default:
      return state
  }
}

const priceDishubUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_UPDATE_LOADING:
      return action.priceDishubUpdateLoading
    default:
      return state
  }
}

const priceDishubUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case HARGA_JUAL_UPDATE_SUCCESS:
      return action.priceDishubUpdateSuccess
    default:
      return state
  }
}

const priceDishubUpdate = (state = [], action) => {
  switch (action.type) {
    case HARGA_JUAL_UPDATE_SUCCESS:
      return action.priceDishubUpdate
    default:
      return state
  }
}

const priceDishubReducer = combineReducers({
  priceDishubListTrayekError,
  priceDishubListTrayekLoading,
  priceDishubListTrayekSuccess,
  priceDishubListTrayek,

  priceDishubListContainerError,
  priceDishubListContainerSuccess,
  priceDishubListContainerLoading,
  priceDishubListContainer,

  priceDishubListScheduleError,
  priceDishubListScheduleSuccess,
  priceDishubListScheduleLoading,
  priceDishubListSchedule,

  priceDishubAddSuccess,
  priceDishubAddLoading,
  priceDishubAddError,
  priceDishubAdd,

  priceDishubUpdateSuccess,
  priceDishubUpdateLoading,
  priceDishubUpdateError,
  priceDishubUpdate,
})

export default priceDishubReducer
